/**
 * PTE Academic — API client. Thin wrapper around /api/pte/*.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const _ax = axios.create({ baseURL: BACKEND_URL, withCredentials: true });

export const pteApi = {
  async config() {
    return (await _ax.get('/api/pte/config')).data;
  },
  async taskTypes(section) {
    const params = section ? { section } : {};
    return (await _ax.get('/api/pte/task-types', { params })).data;
  },
  async strategy(taskType) {
    return (await _ax.get(`/api/pte/strategy/${encodeURIComponent(taskType)}`)).data;
  },
  async pool(taskType, difficulty, count = 5) {
    const params = { task_type: taskType, count };
    if (difficulty) params.difficulty = difficulty;
    return (await _ax.get('/api/pte/practice/pool', { params })).data;
  },
  async submit(payload) {
    return (await _ax.post('/api/pte/submit', payload)).data;
  },
  async dailyChallenge() {
    return (await _ax.get('/api/pte/daily-challenge')).data;
  },
  async submitDaily(payload) {
    return (await _ax.post('/api/pte/daily-challenge/submit', payload)).data;
  },
  async uploadSpeaking(blob, questionId) {
    const fd = new FormData();
    fd.append('audio', blob, 'recording.webm');
    fd.append('question_id', questionId);
    return (await _ax.post('/api/pte/speaking/upload', fd)).data;
  },
  async myDashboard() {
    return (await _ax.get('/api/pte/me/dashboard')).data;
  },
  async simulationHistory() {
    return (await _ax.get('/api/pte/simulation/history')).data;
  },
  async simulationResume() {
    return (await _ax.get('/api/pte/simulation/resume')).data;
  },
  async simulationState(attemptId) {
    return (await _ax.get(`/api/pte/simulation/state/${attemptId}`)).data;
  },
  async mockHistory() {
    return (await _ax.get('/api/pte/mock/history')).data;
  },
  async mockResume() {
    return (await _ax.get('/api/pte/mock/resume')).data;
  },
  async analyticsSummary() {
    return (await _ax.get('/api/pte/analytics/summary')).data;
  },
  async vocabProgress() {
    return (await _ax.get('/api/pte/vocab/progress')).data;
  },
  async getTarget() {
    return (await _ax.get('/api/pte/analytics/target')).data;
  },
  async setTarget(target_score) {
    return (await _ax.post('/api/pte/analytics/target', { target_score })).data;
  },
  async mockReadiness() {
    return (await _ax.get('/api/pte/media/mock-readiness')).data;
  },
};

export const DISCLAIMER =
  'Winhouse Tutors provides independent PTE Academic preparation resources and is not affiliated with or endorsed by Pearson.';
